import React from 'react';

interface CharacterCountProps {
  current: number;
  max: number;
}

const CharacterCount: React.FC<CharacterCountProps> = ({ current, max }) => {
  return (
    <div
      className='flex items-center gap-[6px]'
      data-testid='character-count'
    >
      <span className='text-sm'>
        <span className={current > max ? 'text-warning-500' : ''}>{current || 0}</span>
        <span>/{max}</span>
      </span>
    </div>
  );
};

export default CharacterCount;
